import PokerTablePokerBase from "../../table/module/poker_table/poker_table_poker_base";
import BlackJackSound from "../blackjack_sound";
import { Card, CardNameIndex, CardColor } from "../../table/module/poker_table/poker_table_common";

const { ccclass, property } = cc._decorator;

export default class BlackJackUtility
{
    

    
    static moveToAction(node:cc.Node,pos:cc.Vec2,time:number,comp?:Function,poker?:PokerTablePokerBase,parent:cc.Node=null){
        node.stopAllActions();
        let moveTo = cc.moveTo(time,pos);
        let callFunc = cc.callFunc(()=>{if (comp) {
            if(parent)
            {
                poker.node.parent=parent
                poker.node.position = cc.Vec2.ZERO;
                let nameArr=poker.node.name.split("_")
                let num:number=Number(nameArr[1])
                num-=1
                if(num>0)
                {
                    poker.node.position=new cc.Vec2(poker.node.position.x+num*30,0)
                    if(num>1)
                    {
                        let xPos:number=0;
                        if(parent.name=="pokerPos" )
                        {
                            xPos=(num-1)*7
                            parent.position=new cc.Vec2(parent.position.x-xPos,parent.position.y)
                            cc.log("pokerPos:"+parent.position)
                        }
                        if(parent.name=="leftPokerPos")
                        {
                            if(num==2)
                            {
                                xPos=(num-1)*7
                                parent.position=new cc.Vec2(parent.position.x-xPos,parent.position.y)
                            }
                        }
                        if(parent.name=="leftPokerPos" || parent.name=="rightPokerPos")
                        {
                            if(num==3)
                            {
                                poker.node.position=new cc.Vec2(0,-35)
                            }
                            else if(num==4)
                            {
                                poker.node.position=new cc.Vec2(30,-35)
                            }
                        }
                        
                    }
                }
            }
            comp(poker,parent);
        }})
        node.runAction(cc.sequence(moveTo,callFunc));
    }

    static getOtherSeatNo(myPlayerSeatNo:number,otherIndex:number)
    {
        let dis=otherIndex-2
        let seatNo=myPlayerSeatNo+dis
        if(seatNo>5)
        {
            seatNo=seatNo-5
        }
        else if(seatNo<0)
        {
            seatNo=seatNo+5
        }
        else if(seatNo==0)
        {
            seatNo=5
        }
        return seatNo
    }
    static makePoker(prefabNode:cc.Node,code:number,parentCode:cc.Node,index:number,showFace:boolean=true)
    {
        
        let nodePoker = this.instantiateObj(prefabNode, parentCode)
        let pokerView = nodePoker.getComponent<PokerTablePokerBase>(PokerTablePokerBase)
        pokerView.setCustomGetSpriteFrameKeyByCodeFunc(this.getPokerSpriteKeyByCode.bind(this))
        pokerView.node.active=true;
        pokerView.node.position=cc.v2(0,0)
        pokerView.fillPoker(code)
        pokerView.showBack(!showFace);
        return pokerView
    }
    static instantiateObj(prefabNode: cc.Node, parent: cc.Node): cc.Node {
        var node = cc.instantiate(prefabNode)
        node.position = cc.v2(0, 0)
        node.scale = 1
        node.parent = parent
        return node
    }
    static getPokerSpriteKeyByCode(code: number){
        let card = Card.makeCardByCode(code)
        if(card.index == CardNameIndex.card_big_king){
            return 'Public_大王'
        }
        if(card.index == CardNameIndex.card_small_king){
            return 'Public_小王'
        }
        let key = 'Public_'        
        switch(card.color){
            case CardColor.color_black_heart:
                key += 'heitao_'
                break
            case CardColor.color_red_heart:
                key += 'hongtao_'
                break
            case CardColor.color_plum:
                key += 'meihua_'
                break
            case CardColor.color_square:
                key += 'fangkuai_'
                break
        }
        return key + card.index
    }
    static getConvertToNodeSpaceAR(startNode:cc.Node,endNode:cc.Node)
    {
        if(endNode)
        {
            let world=endNode.parent.convertToWorldSpaceAR(endNode.position);
            return startNode.convertToNodeSpaceAR(world)
        }
        return null
    }
    static schedule(node : cc.Node , callback : ()=>void , delay : number) : cc.Action
    {
        let delayAction = cc.delayTime(delay);
        let sequence = cc.sequence(delayAction , cc.callFunc(callback));
        let action = cc.repeatForever(sequence);
        node.runAction(action);
        return action;
    }

    static playCardTurnAnim(poker: PokerTablePokerBase, parent:cc.Node, duration: number=0.12, delayTime: number=0.01, onFinish: Function){
        let self = this
        let srcScale = cc.v2(poker.node.scaleY, poker.node.scaleY)
        let targetScale = cc.v2(0, poker.node.scaleY)
        
        poker.node.angle=0
        
        let toFace=true; 
        poker.showFace(!toFace)
        poker.showBack(toFace)
        let fun1 = cc.callFunc(function(){
            poker.showFace(toFace)
            poker.showBack(!toFace)
            
        })
        let callFun = cc.callFunc(function(){
            if(onFinish){
                onFinish()
            }
        }.bind(this))
        BlackJackSound.playTurnOver()
        let scale1 = cc.scaleTo(0.2,1.2);
        let scale2 = cc.scaleTo(0.1,1);
        var rotateAnim1 = cc.scaleTo(duration, targetScale.x, targetScale.y)
        var rotateAnim2 = cc.scaleTo(duration, srcScale.x, srcScale.y)
        var seq = cc.sequence([scale1,scale2,rotateAnim1, fun1, rotateAnim2, callFun]);
        poker.node.runAction(seq);
        
    }
    //千分位显示
    static addThousands(number) {
        if (number == undefined) {
            return '0';
        }
        if(number==0){
            return number;
        }else if(number==0.0){
            return number;
        }
        var num = number + "";
        num = num.replace(new RegExp(",","g"),"");
        // 正负号处理
        var symble = "";
        if(/^([-+]).*$/.test(num)) {
            symble = num.replace(/^([-+]).*$/,"$1");
            num = num.replace(/^([-+])(.*)$/,"$2");
        }
        if(/^[0-9]+(\.[0-9]+)?$/.test(num)) {
            var num = num.replace(new RegExp("^[0]+","g"),"");
            if(/^\./.test(num)) {
                num = "0" + num;
            }
            var decimal = num.replace(/^[0-9]+(\.[0-9]+)?$/,"$1");
            var integer= num.replace(/^([0-9]+)(\.[0-9]+)?$/,"$1");
            var re=/(\d+)(\d{3})/;
            while(re.test(integer)){
                integer = integer.replace(re,"$1,$2");
            }
            return symble + integer + decimal;
        } else {
            return number;
        }
    }
}
